import { ProductEnvironment, ForgeCDNEnvironment } from '@atlassian/forge-ui-types/environments';

import { isFedRampInAnyContext } from './isFedRampInAnyContext';

export const getCDNEnvironment = (productEnvironment: ProductEnvironment): ForgeCDNEnvironment => {
	// Resolved through `isFedRampInAnyContext` rather than the ambient, `location`-based
	// `isFedRamp()` so this is also correct during a server render.
	if (isFedRampInAnyContext()) {
		if (productEnvironment === ProductEnvironment.STAGING) {
			return ForgeCDNEnvironment.STAGING;
		} else {
			return ForgeCDNEnvironment.PRODUCTION;
		}
	}

	if (productEnvironment === ProductEnvironment.DEVELOPMENT) {
		return ForgeCDNEnvironment.DEVELOPMENT;
	} else if (productEnvironment === ProductEnvironment.STAGING) {
		return ForgeCDNEnvironment.STAGING;
	} else {
		return ForgeCDNEnvironment.PRODUCTION;
	}
};
